<template>
  <div class="row mt-4">
    <div class="col-lg-7 col-md-11 col-sm-11 px-0 projects-container d-none d-lg-block text-right">
      <div class="image-container">
        <img class="projects-images mx-auto" :src="url" alt="no-image" v-for="(url, index) in images" :key="index" />
      </div>
    </div>

    <div class="col-lg-5 col-md-11 col-sm-11 text-right pr-lg-5">
      <h3 class="text-title">{{ project.title }}</h3>
      <div class="yellowtag-icon">
        <div class="d-flex flex-column yellowtag-content">
          <p class="pclient">
            <span class="field-label">CLIENT NAME:</span> <br>
            {{ project.clientName }}
          </p>
          <p>
            <span class="field-label">LOCATION:</span>
            {{ project.location }}
          </p>
          <p>
            <span class="field-label">SCOPE OF WORKS:</span>
            {{ project.scopeOfWorks }}
          </p>
          <p>
            <span class="field-label">
              PERIMETER FENCE LENGTH:
            </span>
            {{ project.perimeterFenceLength }}
          </p>
        </div>
      </div>

      <div class="col-sm-12 px-0 mb-4 d-lg-none">
        <div class="image-container-small">
          <img class="projects-images projects-images-small" :src="firstImgUrl" alt="no-image" />
          <img class="projects-images projects-images-small" :src="secondImgUrl" alt="no-image" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { BCardGroup } from 'bootstrap-vue/esm/components/card/card-group'
import { BCard } from 'bootstrap-vue/esm/components/card/card'
import _ from 'lodash'

export default {
  name: 'component-right',
  components: {
    BCardGroup,
    BCard,
  },

  props: {
    project: {
      type: Object,
      required: true,
      default: () => { },
    },
  },

  computed: {
    firstImgUrl() {
      return this.project.imageUrls[0].url;
    },
    secondImgUrl() {
      return this.project.imageUrls[1].url;
    },
    images() {
      return _.map(this.project.imageUrls, 'url');
    },
  },
}
</script>

<style scoped>
.field-label {
  font-weight: 900;
}

p {
  line-height: 1rem;
  margin-top: 0;
  margin-bottom: 10px;
}

.pclient {
  font-size: 1.25rem;
  line-height: 1.1;
  margin-bottom: 10px;
  font-weight: bolder;
}

.text-title {
  color: gray;
  font-weight: 700;
  font-size: 1.5rem;
  padding-right: 5px;
}

/* image */
.projects-images {
  width: 200px;
  height: 170px;
  transition: width 0.5s, height 0.5s, transform 0.5s;
  padding-right: 10px;
  padding-top: 10px;
}

.projects-images-small {
  margin-right: -5px;
}

.projects-images:hover {
  transform: scale(1.5, 1.5);
  background-color: #fdb210;
  padding: 7px;
}

/* margin for every product */
.projects-container {
  margin-bottom: 2rem;
  margin-left: 0;
}

.image-container {
  padding: 5px;
  margin-left: 45px;
  margin-bottom: 50px;
  margin-top: 50px;
}

/* yellow tag container */
.yellowtag-icon {
  display: inline-block;
  width: 73%;
  height: 210px;
  margin-top: 7px;
  margin-right: 5px;
  background-color: #fdb210;
  -webkit-border-radius: 3px 4px 4px 3px;
  -moz-border-radius: 3px 4px 4px 3px;
  border-radius: 3px 4px 4px 3px;
  border: 1px solid #fdb210;

  /* This makes room for the triangle */
  position: relative;
  color: black;
  font-weight: 300;
  font-size: 22px;
  line-height: 38px;
}

/* Makes the triangle */
.yellowtag-icon:before {
  content: "";
  position: absolute;
  display: block;
  left: -105px;
  width: 0;
  border-top: 105px solid transparent;
  border-bottom: 105px solid transparent;
  border-right: 105px solid #fdb210;
  height: 210px;
}

/* content of the yellowtag */
.yellowtag-content {
  position: absolute;
  top: 20px;
  right: 5%;
  width: 95%;
}

/* galaxy fold */
@media only screen and (max-width: 280px) {
  .pclient {
    font-size: 0.75rem !important;
  }

  p {
    font-size: 0.65rem !important;
  }
}

@media only screen and (max-width: 600px) {
  p {
    font-size: 0.95rem;
  }

  .pclient {
    font-size: 1rem;
  }

  .yellowtag-icon {
    margin-right: 1%;
  }

  .yellowtag-content {
    width: 97%;
  }
}
</style>

